import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'grid',
      grid: '"logo title action" auto "logo description ." 1fr / 1fr auto 1fr',
      columnGap: Spacings.s32,
      margin: [Spacings.s0, 'auto', Spacings.s48],
      maxWidth: 1076,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        grid: '"logo title" auto "logo action" auto "description description" 1fr / auto 1fr',
        columnGap: Spacings.s16,
        rowGap: Spacings.s16,
      },

      '$.spaced': {
        padding: [Spacings.s32, Spacings.s0],
      },

      [mediaQuery(1365)]: {
        marginBottom: Spacings.s32,
        maxWidth: 934,
      },

      [mediaQuery(1023)]: {
        padding: [Spacings.s0, Spacings.s32],
      },

      [mediaQuery(1023)]: {
        padding: [Spacings.s0, Spacings.s24],
      },
    },
    row: {
      width: '100%',
    },
    logo: {
      gridArea: 'logo',
      width: 150,
      height: 150,
      minWidth: 150,
      borderRadius: '50%',
      overflow: 'hidden',

      [mediaQuery(1365)]: {
        width: 124,
        height: 124,
        minWidth: 124,
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        width: 100,
        height: 100,
        minWidth: 100,
      },
    },
    picture: {
      borderRadius: '50%',
    },
    title: {
      gridArea: 'title',
      marginBottom: Spacings.s4,
      fontSize: FontSizes.s36,
      fontWeight: FontWeights.bold,
      lineHeight: LineHeights.l50,
      color: TextColors.base,

      [mediaQuery(1023)]: {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s16,
        lineHeight: LineHeights.l20,
        maxWidth: 200,
        marginBottom: Spacings.s0,
      },
    },
    description: {
      gridArea: 'description',
      fontSize: FontSizes.s14,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l20,
      color: TextColors.tint1,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s12,
        lineHeight: LineHeights.l16,
      },
    },
    action: {
      gridArea: 'action',
      height: 'initial',
      padding: [Spacings.s16, Spacings.s40],
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.medium,
      textAlign: 'center',

      [mediaQuery(1365)]: {
        padding: [Spacings.s16, Spacings.s24],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s12, Spacings.s16],
        width: 'fit-content',
        minWidth: 116,
      },
    },

    // SKELETON
    fallbackTitle: {
      width: 300,
      height: 50,
    },
    fallbackDescription: {
      width: 500,
      height: 60,
    },
    actionFallback: {
      height: 54,
      padding: 0,
    },
    fallbackParent: {
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        margin: [Spacings.s0, Spacings.s0, Spacings.s32, Spacings.s0],
      },
    },
  }),
  {
    name: 'header-banner-with-dynamic-desktop',
  },
);
export default useStyles;
